<template lang="html">
  <div class="top-nav-bar">
    <div class="top-nav">
      <div class="top-nav__item">
        <v-btn block flat value="organize" @click="onActiveTabChange('organize');">
          <v-icon medium class="organize-icon" :class="menuActive('organize')">outlined_flag</v-icon>
          <span class="nav__text pl-2" :class="menuActive('organize')">Organize</span>
        </v-btn>
      </div>
      <div class="top-nav__item">
        <v-btn flat value="tasks"  @click="onActiveTabChange('tasks')">
          <i class="tasks-icon pr-2" :class="menuActive('tasks')"></i>
          <span class='nav__text pl-2' :class="menuActive('tasks')">Effort</span>
        </v-btn>
      </div>
      <div class="top-nav__item">
        <v-btn flat value="messages" @click="onActiveTabChange('messages')">
          <i class ='message-icon pr-2' :class="menuActive('messages')"></i>
          <span class='nav__text pl-2' :class="menuActive('messages')">Messages</span>
        </v-btn>
      </div>
      <div class="top-nav__item">
        <v-btn flat value="profile" @click="onActiveTabChange('profile')">
          <i class='profile-icon pr-2' :class="menuActive('profile')" ></i>
          <span class='nav__text pl-2' :class="menuActive('profile')">Profile</span>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from '@/mixins/navigation';

export default {
  mixins: [navigation],
  props: ['activeTab'],
  data() {
    return {
    };
  },
  methods: {
    menuActive(item) {
      const active = this.activeTab === item;
      return { active };
    },
    onActiveTabChange(value) {
      this.navigate(value);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

.top-nav-bar {
  display: none;
}

@media only screen and (max-width: 1600px) and (min-width: 600px) {
  .top-nav-bar {
    display: inherit;
  }
}

.top-nav {
  background: $menu-black;
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-around;
}

.top-nav__item {
  width: 100%;
}

.top-nav .btn{
  height: 100%;
  width: 100%;
}

.top-nav .nav__text.active {
  color: $white;
  opacity: 1;
  font-size: 14px;
  font-family: MuseoSans-500;
  font-weight: bold;
}

.top-nav .nav__text {
  color: $white;
  opacity: 0.5;
  font-size: 14px;
  font-family:  MuseoSans-500;
}

.organize-icon {
  color: #939596 !important;
}
.organize-icon.active {
  color: #ffc175 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Topbar.vue